import { RouteRecordRaw } from 'vue-router'
import Dashboard from '@/modules/App/views/AppDashboard.vue'
import Login from './views/UserLogin.vue'
import Signup from './views/UserSignup.vue'
import NotFound from './views/NotFound.vue'
import NotAuthorized from '@/modules/App/views/NotAuthorized.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import EmailActionHandler from './views/EmailActionHandler.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    alias: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { authorize: true }
  },

  {
    path: '/login',
    name: 'Login',
    component: Login
  },

  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/email-action-handler',
    name: 'EmailActionHandler',
    component: EmailActionHandler
  },
  {
    path: '/not-authorized',
    name: 'NotAuthorized',
    component: NotAuthorized
  },
  {
    path: '/waiting-room',
    name: 'WaitingRoom',
    component: () => import('./views/WaitingRoom.vue')
  },
  {
    path: '/:pathMatch(.*)*', //https://router.vuejs.org/guide/migration/#Removed-star-or-catch-all-routes
    name: 'NotFound',
    component: NotFound
  }
]

export default routes
